export const DELETED_USER_FIRST_NAME = 'Deleted';

export const isDeletedUserRecord = (user = {}) => {
  const firstName = user?.firstName ?? user?.user?.firstName;
  return firstName === DELETED_USER_FIRST_NAME;
};

export const excludeDeletedUsers = (users = []) => {
  if (!Array.isArray(users)) {
    return [];
  }

  return users.filter((user) => !isDeletedUserRecord(user));
};
